/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.coaching-subjects'},
});

const CoachingSubjectsItems = () => (
  <RouteLinkItem
    route="midas/microcredentialing/coaching-subjects"
    title={messages.title}
  />
);

export default CoachingSubjectsItems;
